goog.provide("shadow.js.shim.module$$mui$material$CssBaseline");
goog.provide("module$shadow_js_shim_module$$mui$material$CssBaseline");
shadow.js.shim.module$$mui$material$CssBaseline = shadow.js.nativeProvides["@mui/material/CssBaseline"] = shadow$bridge("@mui/material/CssBaseline");
module$shadow_js_shim_module$$mui$material$CssBaseline.default = shadow.js.shim.module$$mui$material$CssBaseline;
